import request from "@/utils/request";

export default function save(params) {
    return request({
        url: `/storeProductSpecification/agency/save`,
        method: 'post',
        data:params
    })
}
